import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseTenantStatementTemplates = [
  {
    id: '-124001',
    language: Language.EN,
    subject: 'Statement of charges',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_TENANT_STATEMENT,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Dear {{listAllTenants lease}},</p>
        <p></p>
        <p>Please find herby attached:
        <ul>
        <li>Your latest statement of charges in relation with the lease located at <strong>{{getLeaseMainAddress lease}}</strong>;</li>
        <li>The {{getInvoiceOrPaymentRequest lease}} clearing your statement of charges.</li>
        </ul></p>
        <p>The balance of the statement is <strong>{{totalAmount}} €</strong>.</p>
        <p></p>
        {{#if correctedVersionNote}}
        <p style="white-space: pre-line">{{correctedVersionNote}}</p>
        <p></p>
        {{/if}}
        <p>Kind regards,</p>
        <p></p>
        <p>{{accountSignature client}}</p>`,
  },
  {
    id: '-124002',
    language: Language.FR,
    subject: 'Décompte  de charges',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_TENANT_STATEMENT,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Cher/Chère {{listAllTenants lease}},</p>
        <p></p>
        <p>Veuillez trouver en pièce jointe:
        <ul>
        <li>Votre dernier décompte de charges concernant le bail sis <strong>{{getLeaseMainAddress lease}}</strong>;</li>
        <li>La {{getInvoiceOrPaymentRequest lease}} soldant votre décompte de charges.</li>
        </ul></p>
        <p>Le solde du décompte est de <strong>{{totalAmount}} €</strong>.</p>
        <p></p>
        {{#if correctedVersionNote}}
        <p style="white-space: pre-line">{{correctedVersionNote}}</p>
        <p></p>
        {{/if}}
        <p>Bien à vous,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-124003',
    language: Language.NL,
    subject: 'Afrekening van huurlasten',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_TENANT_STATEMENT,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Geachte {{listAllTenants lease}},</p>
        <p></p>
        <p>Gelieve het volgende in bijlage te vinden:
        <ul>
        <li>Uw laatste overzicht van de lasten in verband met het huurcontract gelegen op <strong>{{getLeaseMainAddress lease}}</strong>;</li>
        <li>De {{getInvoiceOrPaymentRequest lease}} die uw afrekening van huurlasten vereffent.</li>
        </ul></p>
        <p>Het saldo van de afrekening is <strong>{{totalAmount}} €</strong>.</p>
        <p></p>
        {{#if correctedVersionNote}}
        <p style="white-space: pre-line">{{correctedVersionNote}}</p>
        <p></p>
        {{/if}}
        <p>Met vriendelijke groeten,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-124004',
    language: Language.DE,
    subject: 'Nebenkostenabrechnung',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_TENANT_STATEMENT,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Sehr geehrte/r {{listAllTenants lease}},</p>
        <p></p>
        <p>Im Anhang finden Sie:
        <ul>
        <li>Ihre neueste Nebenkostenabrechnung bezüglich des Mietvertrags für die Immobilie in <strong>{{getLeaseMainAddress lease}}</strong>;</li>
        <li>Die {{getInvoiceOrPaymentRequest lease}} zur Begleichung Ihrer Nebenkostenabrechnung.</li>
        </ul></p>
        <p>Der Saldo der Abrechnung beträgt <strong>{{totalAmount}} €</strong>.</p>
        <p></p>
        {{#if correctedVersionNote}}
        <p style="white-space: pre-line">{{correctedVersionNote}}</p>
        <p></p>
        {{/if}}
        <p>Mit freundlichen Grüßen,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
];
